module.exports = __webpack_public_path__ + "img/reseaux-sociaux.1924d0a.jpeg";